import type { IconData } from '@stacksjs/iconify-core'

export const eraserSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M23.964 2.553c2.02-1.458 4.623-1.386 6.573.13c1.554 1.209 3.88 3.187 7.16 6.368c3.279 3.181 5.319 5.438 6.565 6.947c1.586 1.918 1.664 4.507.135 6.5c-1.595 2.078-4.587 5.55-10.103 10.901a178 178 0 0 1-4.28 4.026c-.653.592-1.5.913-2.37.913c-7.234 0-11.788.08-14.501.16A4.5 4.5 0 0 1 9.9 37.255l-.576-.556c-3.28-3.18-5.32-5.438-6.566-6.946c-1.585-1.918-1.663-4.508-.135-6.5c1.595-2.079 4.588-5.551 10.104-10.902S21.823 4.1 23.964 2.553M8.998 41.5a2.5 2.5 0 0 0 .004 5l35-.027a2.5 2.5 0 0 0-.004-5z\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default eraserSolid
